import Listar from '@/pages/produto/Listar'

export const produtosRoutes = [
    {
        path: '/produtos',
        name: 'produtos',
        component: Listar
    },
]

export default{}